import { VideoReelsTheme } from '@/components/VideoReels/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: VideoReelsTheme });

const Base = $({ as: 'aside', slot: 'base' });
const Heading = $({ as: 'h2', slot: 'heading' });
const Element = $({ as: 'div', slot: 'element' });

export const VideoReels = Object.assign(Base, {
  Heading,
  Element,
});
